//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { IApiConfig } from './ApiConfig';
export class ApiClientBase {
    protected readonly config: IApiConfig;

    protected constructor(config: IApiConfig) {
        this.config = config;
    }

    protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
        options.headers = {
            ...options.headers,
            Authorization: this.config.getAuthorization(),
        };
        // See https://developer.mozilla.org/en-US/docs/Web/API/fetch#parameters
        // We want the cookies to be sent with request (as long as the target domain matches) - VendorId cookie
        options.credentials = 'include';
        return Promise.resolve(options);
    };
}

export class AdminClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    getStatuses(serviceRequestId: string | null | undefined, lifecycleId: string | null | undefined, workOrderId: string | null | undefined, signal?: AbortSignal): Promise<StatusesAdminModel> {
        let url_ = this.baseUrl + "/api/Admin/Statuses?";
        if (serviceRequestId !== undefined && serviceRequestId !== null)
            url_ += "serviceRequestId=" + encodeURIComponent("" + serviceRequestId) + "&";
        if (lifecycleId !== undefined && lifecycleId !== null)
            url_ += "lifecycleId=" + encodeURIComponent("" + lifecycleId) + "&";
        if (workOrderId !== undefined && workOrderId !== null)
            url_ += "workOrderId=" + encodeURIComponent("" + workOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStatuses(_response);
        });
    }

    protected processGetStatuses(response: Response): Promise<StatusesAdminModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StatusesAdminModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatusesAdminModel>(null as any);
    }

    updateStatuses(request: UpdateStatusesAdminRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Admin/UpdateStatuses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateStatuses(_response);
        });
    }

    protected processUpdateStatuses(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AppointmentClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    getUserAppointments(today: string | undefined, signal?: AbortSignal): Promise<AppointmentModel[]> {
        let url_ = this.baseUrl + "/api/Appointment/Query?";
        if (today === null)
            throw new Error("The parameter 'today' cannot be null.");
        else if (today !== undefined)
            url_ += "today=" + encodeURIComponent("" + today) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserAppointments(_response);
        });
    }

    protected processGetUserAppointments(response: Response): Promise<AppointmentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppointmentModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppointmentModel[]>(null as any);
    }

    completeAppointment(id: string, request: CompleteAppointmentRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Appointment/{id}/Complete";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCompleteAppointment(_response);
        });
    }

    protected processCompleteAppointment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getUserAppointmentsByDate(date: string, signal?: AbortSignal): Promise<AppointmentModel[]> {
        let url_ = this.baseUrl + "/api/Appointment/Query/{date}";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserAppointmentsByDate(_response);
        });
    }

    protected processGetUserAppointmentsByDate(response: Response): Promise<AppointmentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AppointmentModel[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppointmentModel[]>(null as any);
    }
}

export class CommandClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    submitOrderCommand(orderId: string, commandId: string, request: SubmitOrderCommandRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Command/order/{orderId}/command/{commandId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitOrderCommand(_response);
        });
    }

    protected processSubmitOrderCommand(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    submitOrderFileCommand(orderId: string, commandId: string, fileId: string, file: FileParameter | null | undefined, timestamp: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Command/order/{orderId}/command/{commandId}/{fileId}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (timestamp === null || timestamp === undefined)
            throw new Error("The parameter 'timestamp' cannot be null.");
        else
            content_.append("Timestamp", timestamp.toString());

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitOrderFileCommand(_response);
        });
    }

    protected processSubmitOrderFileCommand(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    submitOrderFileChunkCommand(orderId: string, commandId: string, fileId: string, file: FileParameter | null | undefined, chunkIndex: number | undefined, totalChunks: number | undefined, timestamp: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Command/order/{orderId}/command/{commandId}/{fileId}/chunk";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (commandId === undefined || commandId === null)
            throw new Error("The parameter 'commandId' must be defined.");
        url_ = url_.replace("{commandId}", encodeURIComponent("" + commandId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (chunkIndex === null || chunkIndex === undefined)
            throw new Error("The parameter 'chunkIndex' cannot be null.");
        else
            content_.append("ChunkIndex", chunkIndex.toString());
        if (totalChunks === null || totalChunks === undefined)
            throw new Error("The parameter 'totalChunks' cannot be null.");
        else
            content_.append("TotalChunks", totalChunks.toString());
        if (timestamp === null || timestamp === undefined)
            throw new Error("The parameter 'timestamp' cannot be null.");
        else
            content_.append("Timestamp", timestamp.toString());

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmitOrderFileChunkCommand(_response);
        });
    }

    protected processSubmitOrderFileChunkCommand(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    test(request: TestRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Command/test";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTest(_response);
        });
    }

    protected processTest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ConditionIssueInstanceClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    createConditionIssueInstance(request: CreateConditionIssueInstanceRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/ConditionIssueInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateConditionIssueInstance(_response);
        });
    }

    protected processCreateConditionIssueInstance(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteConditionIssueInstance(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/ConditionIssueInstance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteConditionIssueInstance(_response);
        });
    }

    protected processDeleteConditionIssueInstance(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateConditionIssueInstance(id: string, request: UpdateConditionIssueInstanceRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/ConditionIssueInstance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateConditionIssueInstance(_response);
        });
    }

    protected processUpdateConditionIssueInstance(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateConditionIssueInstanceStatus(id: string, request: UpdateConditionIssueInstanceStatusRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/ConditionIssueInstance/{id}/Status";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateConditionIssueInstanceStatus(_response);
        });
    }

    protected processUpdateConditionIssueInstanceStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    batchUpdateConditionIssueInstanceEstimatedDuration(request: BatchUpdateConditionIssueInstanceEstimatedDurationRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/ConditionIssueInstance/Batch/UpdateEstimatedDuration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchUpdateConditionIssueInstanceEstimatedDuration(_response);
        });
    }

    protected processBatchUpdateConditionIssueInstanceEstimatedDuration(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    escalateConditionIssueInstance(id: string, request: EscalateConditionIssueInstanceRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/ConditionIssueInstance/{id}/Escalate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEscalateConditionIssueInstance(_response);
        });
    }

    protected processEscalateConditionIssueInstance(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse2;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    evaluateStateMachine(id: string, actionName: string, actionParameters: { [key: string]: any; } | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/ConditionIssueInstance/{id}/Evaluate/{actionName}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (actionName === undefined || actionName === null)
            throw new Error("The parameter 'actionName' must be defined.");
        url_ = url_.replace("{actionName}", encodeURIComponent("" + actionName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(actionParameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEvaluateStateMachine(_response);
        });
    }

    protected processEvaluateStateMachine(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EmployeeClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    getEmployeesWithRole(roleId: string | undefined, signal?: AbortSignal): Promise<EmployeeModel[]> {
        let url_ = this.baseUrl + "/api/Employee?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmployeesWithRole(_response);
        });
    }

    protected processGetEmployeesWithRole(response: Response): Promise<EmployeeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EmployeeModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EmployeeModel[]>(null as any);
    }
}

export class FileClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    getTypedAttributes(attributes: string | null | undefined, signal?: AbortSignal): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/File?";
        if (attributes !== undefined && attributes !== null)
            url_ += "attributes=" + encodeURIComponent("" + attributes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTypedAttributes(_response);
        });
    }

    protected processGetTypedAttributes(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: string; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    uploadFile(fileId: string | undefined, file: FileParameter | null | undefined, attributes: string | null | undefined, signal?: AbortSignal): Promise<FileUploadResponse> {
        let url_ = this.baseUrl + "/api/File";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileId === null || fileId === undefined)
            throw new Error("The parameter 'fileId' cannot be null.");
        else
            content_.append("FileId", fileId.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (attributes !== null && attributes !== undefined)
            content_.append("Attributes", attributes.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadFile(_response);
        });
    }

    protected processUploadFile(response: Response): Promise<FileUploadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileUploadResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileUploadResponse>(null as any);
    }

    deleteFile(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/File/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFile(_response);
        });
    }

    protected processDeleteFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getConditionIssueInstanceFiles(id: string, signal?: AbortSignal): Promise<FileModel[]> {
        let url_ = this.baseUrl + "/api/File/ConditionIssueInstance/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetConditionIssueInstanceFiles(_response);
        });
    }

    protected processGetConditionIssueInstanceFiles(response: Response): Promise<FileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileModel[]>(null as any);
    }

    getVendorTermsAndConditionsFileUrl(signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/File/GetVendorTermsAndConditionsFileUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVendorTermsAndConditionsFileUrl(_response);
        });
    }

    protected processGetVendorTermsAndConditionsFileUrl(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getVendorTrainingVideos(signal?: AbortSignal): Promise<FileModel[]> {
        let url_ = this.baseUrl + "/api/File/VendorTrainingVideos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVendorTrainingVideos(_response);
        });
    }

    protected processGetVendorTrainingVideos(response: Response): Promise<FileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileModel[]>(null as any);
    }
}

export class GeotabClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    geotabDevices(signal?: AbortSignal): Promise<FindAssetResponse> {
        let url_ = this.baseUrl + "/api/Geotab/Devices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGeotabDevices(_response);
        });
    }

    protected processGeotabDevices(response: Response): Promise<FindAssetResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FindAssetResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FindAssetResponse>(null as any);
    }

    updateResourceDeviceRelation(request: UpdateDeviceResourceRelationRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Geotab/Device";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateResourceDeviceRelation(_response);
        });
    }

    protected processUpdateResourceDeviceRelation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class InventoryClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    userInventory(signal?: AbortSignal): Promise<UserInventoryResponse> {
        let url_ = this.baseUrl + "/api/Inventory/UserInventory";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserInventory(_response);
        });
    }

    protected processUserInventory(response: Response): Promise<UserInventoryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserInventoryResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInventoryResponse>(null as any);
    }

    issueInventory(request: IssueInventoryRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Inventory/IssueInventory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIssueInventory(_response);
        });
    }

    protected processIssueInventory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    receiveInventory(request: ReceiveInventoryRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Inventory/ReceiveInventory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReceiveInventory(_response);
        });
    }

    protected processReceiveInventory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LocationClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    createLocation(request: CreateLocationRequest, signal?: AbortSignal): Promise<CreateLocationResponse> {
        let url_ = this.baseUrl + "/api/Location";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateLocation(_response);
        });
    }

    protected processCreateLocation(response: Response): Promise<CreateLocationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateLocationResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateLocationResponse>(null as any);
    }

    updateLocation(id: string, request: UpdateLocationRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Location/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateLocation(_response);
        });
    }

    protected processUpdateLocation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteLocation(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Location/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteLocation(_response);
        });
    }

    protected processDeleteLocation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getLocationById(id: string, signal?: AbortSignal): Promise<LocationModel> {
        let url_ = this.baseUrl + "/api/Location/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLocationById(_response);
        });
    }

    protected processGetLocationById(response: Response): Promise<LocationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LocationModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationModel>(null as any);
    }

    searchLocations(request: SearchLocationRequest, signal?: AbortSignal): Promise<SearchLocationResponse> {
        let url_ = this.baseUrl + "/api/Location/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchLocations(_response);
        });
    }

    protected processSearchLocations(response: Response): Promise<SearchLocationResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchLocationResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchLocationResponse>(null as any);
    }
}

export class LockboxClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    accessCode(request: AccessCodeRequest, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/Lockbox/AccessCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAccessCode(_response);
        });
    }

    protected processAccessCode(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    search(request: SearchLockboxRequest, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/Lockbox/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    installLockbox(request: InstallLockboxRequest, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/Lockbox/Install";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processInstallLockbox(_response);
        });
    }

    protected processInstallLockbox(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    uninstallLockbox(request: UninstallLockboxRequest, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/Lockbox/Uninstall";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUninstallLockbox(_response);
        });
    }

    protected processUninstallLockbox(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class LogClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    addLog(request: CreateLogRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddLog(_response);
        });
    }

    protected processAddLog(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class NotificationClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    get(signal?: AbortSignal): Promise<NotificationModel[]> {
        let url_ = this.baseUrl + "/api/Notification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<NotificationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NotificationModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationModel[]>(null as any);
    }

    pin(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Notification/Pin/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPin(_response);
        });
    }

    protected processPin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    unpin(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Notification/Pin/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnpin(_response);
        });
    }

    protected processUnpin(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OrderClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    query(today: string | undefined, loadFiles: boolean | undefined, signal?: AbortSignal): Promise<OrderDetailsResponse[]> {
        let url_ = this.baseUrl + "/api/Order/Query?";
        if (today === null)
            throw new Error("The parameter 'today' cannot be null.");
        else if (today !== undefined)
            url_ += "today=" + encodeURIComponent("" + today) + "&";
        if (loadFiles === null)
            throw new Error("The parameter 'loadFiles' cannot be null.");
        else if (loadFiles !== undefined)
            url_ += "loadFiles=" + encodeURIComponent("" + loadFiles) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: Response): Promise<OrderDetailsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrderDetailsResponse[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDetailsResponse[]>(null as any);
    }

    queryByDate(date: string, loadFiles: boolean | undefined, signal?: AbortSignal): Promise<OrderDetailsResponse[]> {
        let url_ = this.baseUrl + "/api/Order/Query/{date}?";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        if (loadFiles === null)
            throw new Error("The parameter 'loadFiles' cannot be null.");
        else if (loadFiles !== undefined)
            url_ += "loadFiles=" + encodeURIComponent("" + loadFiles) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQueryByDate(_response);
        });
    }

    protected processQueryByDate(response: Response): Promise<OrderDetailsResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrderDetailsResponse[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDetailsResponse[]>(null as any);
    }

    queryOrderFiles(today: string | undefined, signal?: AbortSignal): Promise<QueryOrderFilesResponse> {
        let url_ = this.baseUrl + "/api/Order/Query/Files?";
        if (today === null)
            throw new Error("The parameter 'today' cannot be null.");
        else if (today !== undefined)
            url_ += "today=" + encodeURIComponent("" + today) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processQueryOrderFiles(_response);
        });
    }

    protected processQueryOrderFiles(response: Response): Promise<QueryOrderFilesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOrderFilesResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOrderFilesResponse>(null as any);
    }

    findById(orderId: string, today: string | undefined, signal?: AbortSignal): Promise<OrderDetailsResponse> {
        let url_ = this.baseUrl + "/api/Order/{orderId}?";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (today === null)
            throw new Error("The parameter 'today' cannot be null.");
        else if (today !== undefined)
            url_ += "today=" + encodeURIComponent("" + today) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFindById(_response);
        });
    }

    protected processFindById(response: Response): Promise<OrderDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrderDetailsResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderDetailsResponse>(null as any);
    }

    getOrderFiles(orderId: string, signal?: AbortSignal): Promise<QueryOrderFilesResponse> {
        let url_ = this.baseUrl + "/api/Order/{orderId}/Files";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetOrderFiles(_response);
        });
    }

    protected processGetOrderFiles(response: Response): Promise<QueryOrderFilesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QueryOrderFilesResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QueryOrderFilesResponse>(null as any);
    }

    search(request: SearchWorkOrdersRequest, signal?: AbortSignal): Promise<OrderModel[]> {
        let url_ = this.baseUrl + "/api/Order/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<OrderModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OrderModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrderModel[]>(null as any);
    }

    getVendorAdminOrders(request: VendorAdminOrdersRequest, signal?: AbortSignal): Promise<VendorAdminOrdersResponse> {
        let url_ = this.baseUrl + "/api/Order/VendorAdminOrders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVendorAdminOrders(_response);
        });
    }

    protected processGetVendorAdminOrders(response: Response): Promise<VendorAdminOrdersResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VendorAdminOrdersResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VendorAdminOrdersResponse>(null as any);
    }

    getVendorAdminNotes(signal?: AbortSignal): Promise<VendorAdminNotesOrderModel[]> {
        let url_ = this.baseUrl + "/api/Order/VendorAdminNotes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVendorAdminNotes(_response);
        });
    }

    protected processGetVendorAdminNotes(response: Response): Promise<VendorAdminNotesOrderModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VendorAdminNotesOrderModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VendorAdminNotesOrderModel[]>(null as any);
    }

    getVendorNewOrders(signal?: AbortSignal): Promise<VendorAdminOrderModel[]> {
        let url_ = this.baseUrl + "/api/Order/VendorNewOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVendorNewOrders(_response);
        });
    }

    protected processGetVendorNewOrders(response: Response): Promise<VendorAdminOrderModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VendorAdminOrderModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VendorAdminOrderModel[]>(null as any);
    }

    mutateState(request: MutateOrderStateRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Order/MutateState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMutateState(_response);
        });
    }

    protected processMutateState(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setInspected(id: string, targetId: string, inspected: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Order/{id}/SetInspected/{targetId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (targetId === undefined || targetId === null)
            throw new Error("The parameter 'targetId' must be defined.");
        url_ = url_.replace("{targetId}", encodeURIComponent("" + targetId));
        if (inspected === null)
            throw new Error("The parameter 'inspected' cannot be null.");
        else if (inspected !== undefined)
            url_ += "inspected=" + encodeURIComponent("" + inspected) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetInspected(_response);
        });
    }

    protected processSetInspected(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @deprecated
     */
    addServiceTasks(id: string, serviceTaskModels: NewServiceTaskModel[], signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/Order/{id}/AddServiceTasks";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serviceTaskModels);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddServiceTasks(_response);
        });
    }

    protected processAddServiceTasks(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    addServiceTask(id: string, request: CreateServiceTaskRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Order/{id}/ServiceTask";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddServiceTask(_response);
        });
    }

    protected processAddServiceTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateServiceTask(id: string, serviceTaskId: string, request: UpdateServiceTaskRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Order/{id}/ServiceTask/{serviceTaskId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (serviceTaskId === undefined || serviceTaskId === null)
            throw new Error("The parameter 'serviceTaskId' must be defined.");
        url_ = url_.replace("{serviceTaskId}", encodeURIComponent("" + serviceTaskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateServiceTask(_response);
        });
    }

    protected processUpdateServiceTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    addNote(request: AddOrUpdateNoteRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Order/Notes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddNote(_response);
        });
    }

    protected processAddNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateNote(request: AddOrUpdateNoteRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Order/Notes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNote(_response);
        });
    }

    protected processUpdateNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateNoteStatus(id: string, isRead: boolean, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Order/NoteStatus/{id}/{isRead}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (isRead === undefined || isRead === null)
            throw new Error("The parameter 'isRead' must be defined.");
        url_ = url_.replace("{isRead}", encodeURIComponent("" + isRead));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNoteStatus(_response);
        });
    }

    protected processUpdateNoteStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updatePreferredTimes(id: string, request: UpdatePreferredTimesRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Order/{id}/PreferredTimes";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdatePreferredTimes(_response);
        });
    }

    protected processUpdatePreferredTimes(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    batchUpdateNoteStatus(request: BatchUpdateNoteStatusRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Order/Batch/UpdateNoteStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchUpdateNoteStatus(_response);
        });
    }

    protected processBatchUpdateNoteStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    batchUpdateBookingLock(request: BatchUpdateBookingLockRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Order/Batch/UpdateBookingLock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBatchUpdateBookingLock(_response);
        });
    }

    protected processBatchUpdateBookingLock(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    evaluateStateMachine(orderId: string, actionName: string, actionParameters: { [key: string]: any; } | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Order/{orderId}/Evaluate/{actionName}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (actionName === undefined || actionName === null)
            throw new Error("The parameter 'actionName' must be defined.");
        url_ = url_.replace("{actionName}", encodeURIComponent("" + actionName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(actionParameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEvaluateStateMachine(_response);
        });
    }

    protected processEvaluateStateMachine(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    evaluateServiceTaskStatus(orderId: string, serviceTaskId: string, actionName: string, actionParameters: { [key: string]: any; }, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Order/{orderId}/ServiceTask/{serviceTaskId}/Evaluate/{actionName}";
        if (orderId === undefined || orderId === null)
            throw new Error("The parameter 'orderId' must be defined.");
        url_ = url_.replace("{orderId}", encodeURIComponent("" + orderId));
        if (serviceTaskId === undefined || serviceTaskId === null)
            throw new Error("The parameter 'serviceTaskId' must be defined.");
        url_ = url_.replace("{serviceTaskId}", encodeURIComponent("" + serviceTaskId));
        if (actionName === undefined || actionName === null)
            throw new Error("The parameter 'actionName' must be defined.");
        url_ = url_.replace("{actionName}", encodeURIComponent("" + actionName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(actionParameters);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processEvaluateServiceTaskStatus(_response);
        });
    }

    protected processEvaluateServiceTaskStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PropertyClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    setCoordinates(request: SetCoordinatesRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Property/SetCoordinates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetCoordinates(_response);
        });
    }

    protected processSetCoordinates(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getProperty(id: string, signal?: AbortSignal): Promise<PropertyModel> {
        let url_ = this.baseUrl + "/api/Property/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetProperty(_response);
        });
    }

    protected processGetProperty(response: Response): Promise<PropertyModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PropertyModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyModel>(null as any);
    }

    getHistory(id: string, signal?: AbortSignal): Promise<PropertyHistoryModel> {
        let url_ = this.baseUrl + "/api/Property/{id}/History";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetHistory(_response);
        });
    }

    protected processGetHistory(response: Response): Promise<PropertyHistoryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PropertyHistoryModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PropertyHistoryModel>(null as any);
    }
}

export class ReferenceClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    getGlobalData(signal?: AbortSignal): Promise<GlobalReferenceDataModel> {
        let url_ = this.baseUrl + "/api/Reference/Global";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGlobalData(_response);
        });
    }

    protected processGetGlobalData(response: Response): Promise<GlobalReferenceDataModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GlobalReferenceDataModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlobalReferenceDataModel>(null as any);
    }

    getUserData(signal?: AbortSignal): Promise<UserReferenceDataModel> {
        let url_ = this.baseUrl + "/api/Reference/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserData(_response);
        });
    }

    protected processGetUserData(response: Response): Promise<UserReferenceDataModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserReferenceDataModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserReferenceDataModel>(null as any);
    }
}

export class RemedyClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    /**
     * @deprecated
     */
    getRemedies(signal?: AbortSignal): Promise<RemedyModel[]> {
        let url_ = this.baseUrl + "/api/Remedy";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRemedies(_response);
        });
    }

    protected processGetRemedies(response: Response): Promise<RemedyModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RemedyModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RemedyModel[]>(null as any);
    }
}

export class RemedyInstanceClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    createRemedyInstance(request: CreateRemedyInstanceRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/RemedyInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRemedyInstance(_response);
        });
    }

    protected processCreateRemedyInstance(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateRemedyInstance(request: UpdateRemedyInstanceRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/RemedyInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateRemedyInstance(_response);
        });
    }

    protected processUpdateRemedyInstance(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateRemedyInstanceAssignment(id: string, request: UpdateRemedyInstanceAssignmentRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/RemedyInstance/{id}/Assignment";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateRemedyInstanceAssignment(_response);
        });
    }

    protected processUpdateRemedyInstanceAssignment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateRemedyInstanceAssignments(request: BatchUpdateRemedyInstanceAssignmentRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/RemedyInstance/Assignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateRemedyInstanceAssignments(_response);
        });
    }

    protected processUpdateRemedyInstanceAssignments(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateRemedyInstanceService(id: string, request: UpdateRemedyInstanceServiceRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/RemedyInstance/{id}/Service";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateRemedyInstanceService(_response);
        });
    }

    protected processUpdateRemedyInstanceService(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteRemedyInstance(id: string, orderId: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/RemedyInstance/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRemedyInstance(_response);
        });
    }

    protected processDeleteRemedyInstance(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ResourceClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    getResourcesForVendor(vendorId: string | undefined, signal?: AbortSignal): Promise<ResourceModel[]> {
        let url_ = this.baseUrl + "/api/Resource/Vendor?";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResourcesForVendor(_response);
        });
    }

    protected processGetResourcesForVendor(response: Response): Promise<ResourceModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResourceModel[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceModel[]>(null as any);
    }
}

export class ReviewClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    getInspection(id: string, signal?: AbortSignal): Promise<InspectionModel> {
        let url_ = this.baseUrl + "/api/Review/Inspection/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInspection(_response);
        });
    }

    protected processGetInspection(response: Response): Promise<InspectionModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InspectionModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InspectionModel>(null as any);
    }

    createReview(request: CreateReviewRequest, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/Review";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateReview(_response);
        });
    }

    protected processCreateReview(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    searchReviews(request: SearchReviewsRequest, signal?: AbortSignal): Promise<SearchReviewsResponse> {
        let url_ = this.baseUrl + "/api/Review/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchReviews(_response);
        });
    }

    protected processSearchReviews(response: Response): Promise<SearchReviewsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchReviewsResponse;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchReviewsResponse>(null as any);
    }

    approveReview(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Review/{id}/Approve";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApproveReview(_response);
        });
    }

    protected processApproveReview(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    rejectReview(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Review/{id}/Reject";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRejectReview(_response);
        });
    }

    protected processRejectReview(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SandboxClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    purgeCache(signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Sandbox/PurgeCache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPurgeCache(_response);
        });
    }

    protected processPurgeCache(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class UmbracoContentClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    getVendorOfficeInfo(signal?: AbortSignal): Promise<VendorOfficeInfoModel> {
        let url_ = this.baseUrl + "/api/UmbracoContent/VendorOfficeInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVendorOfficeInfo(_response);
        });
    }

    protected processGetVendorOfficeInfo(response: Response): Promise<VendorOfficeInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VendorOfficeInfoModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VendorOfficeInfoModel>(null as any);
    }
}

export class UserClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    getCurrent(vendorId: string | null | undefined, signal?: AbortSignal): Promise<UserModel> {
        let url_ = this.baseUrl + "/api/User/CurrentUser?";
        if (vendorId !== undefined && vendorId !== null)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCurrent(_response);
        });
    }

    protected processGetCurrent(response: Response): Promise<UserModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UserModel;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserModel>(null as any);
    }

    updateCurrentGeoCoordinates(request: UpdateCurrentGeoCoordinatesRequest, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/User/CurrentUser/CurrentGeoCoordinates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateCurrentGeoCoordinates(_response);
        });
    }

    protected processUpdateCurrentGeoCoordinates(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BaseErrorsResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class VoiceInspectionClient extends ApiClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IApiConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://app.sit.amh.com/services-api";
    }

    createSession(request: CreateVoiceInspectionSessionRequest, signal?: AbortSignal): Promise<CreateVoiceInspectionSessionResponse> {
        let url_ = this.baseUrl + "/api/VoiceInspection/Sessions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateSession(_response);
        });
    }

    protected processCreateSession(response: Response): Promise<CreateVoiceInspectionSessionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateVoiceInspectionSessionResponse;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateVoiceInspectionSessionResponse>(null as any);
    }

    getSession(sessionId: string, signal?: AbortSignal): Promise<VoiceInspectionSessionSnapshot> {
        let url_ = this.baseUrl + "/api/VoiceInspection/Sessions/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSession(_response);
        });
    }

    protected processGetSession(response: Response): Promise<VoiceInspectionSessionSnapshot> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoiceInspectionSessionSnapshot;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoiceInspectionSessionSnapshot>(null as any);
    }

    createRealtimeConnection(sessionId: string, signal?: AbortSignal): Promise<VoiceInspectionRealtimeConnectionResponse> {
        let url_ = this.baseUrl + "/api/VoiceInspection/Sessions/{sessionId}/RealtimeConnection";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRealtimeConnection(_response);
        });
    }

    protected processCreateRealtimeConnection(response: Response): Promise<VoiceInspectionRealtimeConnectionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoiceInspectionRealtimeConnectionResponse;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoiceInspectionRealtimeConnectionResponse>(null as any);
    }

    previewFindingPrice(sessionId: string, findingId: string, selectedRemedyId: string | undefined, assignmentTypeId: string | null | undefined, signal?: AbortSignal): Promise<VoiceInspectionPricePreview> {
        let url_ = this.baseUrl + "/api/VoiceInspection/Sessions/{sessionId}/Findings/{findingId}/PricePreview?";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (findingId === undefined || findingId === null)
            throw new Error("The parameter 'findingId' must be defined.");
        url_ = url_.replace("{findingId}", encodeURIComponent("" + findingId));
        if (selectedRemedyId === null)
            throw new Error("The parameter 'selectedRemedyId' cannot be null.");
        else if (selectedRemedyId !== undefined)
            url_ += "selectedRemedyId=" + encodeURIComponent("" + selectedRemedyId) + "&";
        if (assignmentTypeId !== undefined && assignmentTypeId !== null)
            url_ += "assignmentTypeId=" + encodeURIComponent("" + assignmentTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPreviewFindingPrice(_response);
        });
    }

    protected processPreviewFindingPrice(response: Response): Promise<VoiceInspectionPricePreview> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoiceInspectionPricePreview;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoiceInspectionPricePreview>(null as any);
    }

    patchFinding(sessionId: string, findingId: string, patch: VoiceInspectionFindingPatch, signal?: AbortSignal): Promise<VoiceInspectionSessionSnapshot> {
        let url_ = this.baseUrl + "/api/VoiceInspection/Sessions/{sessionId}/Findings/{findingId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (findingId === undefined || findingId === null)
            throw new Error("The parameter 'findingId' must be defined.");
        url_ = url_.replace("{findingId}", encodeURIComponent("" + findingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(patch);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPatchFinding(_response);
        });
    }

    protected processPatchFinding(response: Response): Promise<VoiceInspectionSessionSnapshot> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoiceInspectionSessionSnapshot;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoiceInspectionSessionSnapshot>(null as any);
    }

    deleteFinding(sessionId: string, findingId: string, signal?: AbortSignal): Promise<VoiceInspectionSessionSnapshot> {
        let url_ = this.baseUrl + "/api/VoiceInspection/Sessions/{sessionId}/Findings/{findingId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (findingId === undefined || findingId === null)
            throw new Error("The parameter 'findingId' must be defined.");
        url_ = url_.replace("{findingId}", encodeURIComponent("" + findingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteFinding(_response);
        });
    }

    protected processDeleteFinding(response: Response): Promise<VoiceInspectionSessionSnapshot> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoiceInspectionSessionSnapshot;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoiceInspectionSessionSnapshot>(null as any);
    }

    complete(sessionId: string, signal?: AbortSignal): Promise<VoiceInspectionSessionSnapshot> {
        let url_ = this.baseUrl + "/api/VoiceInspection/Sessions/{sessionId}/Complete";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processComplete(_response);
        });
    }

    protected processComplete(response: Response): Promise<VoiceInspectionSessionSnapshot> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoiceInspectionSessionSnapshot;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoiceInspectionSessionSnapshot>(null as any);
    }

    submit(sessionId: string, request: SubmitVoiceInspectionSessionRequest, signal?: AbortSignal): Promise<VoiceInspectionSessionSnapshot> {
        let url_ = this.baseUrl + "/api/VoiceInspection/Sessions/{sessionId}/Submit";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSubmit(_response);
        });
    }

    protected processSubmit(response: Response): Promise<VoiceInspectionSessionSnapshot> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VoiceInspectionSessionSnapshot;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoiceInspectionSessionSnapshot>(null as any);
    }
}

export interface StatusesAdminModel {
    serviceRequestId?: string | undefined;
    lifecycleId?: string | undefined;
    number?: string | undefined;
    statusId?: string | undefined;
    statusName?: string | undefined;
    subStatusId?: string | undefined;
    subStatusName?: string | undefined;
    workOrders: WorkOrderStatusModel[];
    conditionIssueInstances?: ConditionIssueInstanceStatusModel[] | undefined;
    bids: BidStatusModel[];
}

export interface WorkOrderStatusModel {
    name: string;
    id: string;
    statusId: string;
    statusName: string;
    subStatusId?: string | undefined;
    subStatusName?: string | undefined;
    resourceBookings: ResourceBookingStatusModel[];
    conditionIssueInstances: ConditionIssueInstanceStatusModel[];
}

export interface ResourceBookingStatusModel {
    startTime: string;
    endTime: string;
    resourceName: string;
    id: string;
    statusId: string;
    statusName: string;
}

export interface ConditionIssueInstanceStatusModel {
    id: string;
    name: string;
    statusId: string;
    statusName: string;
    serviceTasks: ServiceTaskStatusModel[];
}

export interface ServiceTaskStatusModel {
    id: string;
    name: string;
    statusId: string;
    statusName: string;
}

export interface BidStatusModel {
    id: string;
    name: string;
    conditionIssueInstanceId: string;
    statusId: string;
    statusName: string;
    options: BidOptionStatusModel[];
}

export interface BidOptionStatusModel {
    id: string;
    name: string;
    statusId?: string | undefined;
    statusName?: string | undefined;
}

export interface BaseResponse {
    success?: boolean;
    errorMessage?: string | undefined;
    errorCode?: string | undefined;
}

export interface BaseErrorsResponse extends BaseResponse {
    errors?: ErrorResponse[] | undefined;
    status?: number;
}

export interface ErrorResponse {
    message?: string | undefined;
    code?: string | undefined;
    field?: string | undefined;
}

export interface UpdateStatusesAdminRequest {
    serviceRequestId?: string | undefined;
    lifecycleId?: string | undefined;
    statusId?: string | undefined;
    subStatusId?: string | undefined;
    conditionIssueInstances?: UpdateConditionIssueInstanceStatus[] | undefined;
    workOrders?: UpdateWorkOrderStatuses[] | undefined;
    bids?: UpdateBidStatus[] | undefined;
}

export interface UpdateConditionIssueInstanceStatus {
    id: string;
    statusId?: string | undefined;
    serviceTasks?: UpdateServiceTaskStatus[] | undefined;
}

export interface UpdateServiceTaskStatus {
    id: string;
    statusId?: string | undefined;
}

export interface UpdateWorkOrderStatuses {
    id: string;
    statusId?: string | undefined;
    subStatusId?: string | undefined;
    resourceBookings?: UpdateResourceBookingStatus[] | undefined;
    conditionIssueInstances?: UpdateConditionIssueInstanceStatus[] | undefined;
}

export interface UpdateResourceBookingStatus {
    id: string;
    statusId?: string | undefined;
}

export interface UpdateBidStatus {
    id: string;
    statusId?: string | undefined;
    options?: UpdateBidOptionStatus[] | undefined;
}

export interface UpdateBidOptionStatus {
    id: string;
    statusId?: string | undefined;
}

export interface AppointmentModel {
    id: string;
    userId: string;
    typeId: string;
    typeName: string;
    description: string;
    startTime: string;
    endTime: string;
    longitude?: number | undefined;
    latitude?: number | undefined;
    isCompleted?: boolean;
    isLocked?: boolean;
    properties: AppointmentPropertiesModel;
}

export interface AppointmentPropertiesModel {
    isAssignedForTomorrow: boolean;
    isAssignedForToday: boolean;
}

export interface CompleteAppointmentRequest {
    isCompleted: boolean;
}

export interface SubmitOrderCommandRequest {
    commandType: string;
    payload?: any | undefined;
    timestamp: string;
}

export interface TestRequest {
    id?: string;
    name?: string | undefined;
}

export interface IdModel {
    id: string;
}

export interface EntityWithNameModel extends IdModel {
    name: string;
}

export interface CreateConditionIssueInstanceRequest extends EntityWithNameModel {
    conditionIssueId: string;
    propertyId: string;
    assetId?: string | undefined;
    assetTypeId?: string | undefined;
    locationId?: string | undefined;
    locationTypeId?: string | undefined;
    orderId: string;
    notes: string;
}

export interface UpdateConditionIssueInstanceStatusRequest {
    statusId: string;
}

export interface UpdateConditionIssueInstanceRequest {
    description?: string | undefined;
    priorityId?: string | undefined;
    assetId?: string | undefined;
    conditionIssueId?: string | undefined;
}

export interface BatchUpdateConditionIssueInstanceEstimatedDurationRequest {
    operations?: UpdateConditionIssueInstanceEstimatedDurationRequest[] | undefined;
}

export interface UpdateConditionIssueInstanceEstimatedDurationRequest {
    id: string;
    estimatedDuration: number;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export interface BaseResponse2 {
    success?: boolean;
    errorMessage?: string | undefined;
    errorCode?: string | undefined;
}

export interface BaseErrorsResponse2 extends BaseResponse2 {
    errors?: ErrorResponse2[] | undefined;
    status?: number;
}

export interface ErrorResponse2 {
    message?: string | undefined;
    code?: string | undefined;
    field?: string | undefined;
}

export interface EscalateConditionIssueInstanceRequest {
    noteId: string;
    noteTitle: string;
    note: string;
    childOrderNoteId: string;
    childOrderId: string;
    timestamp?: string | undefined;
    type: EscalationType;
}

export enum EscalationType {
    Manager = 1,
    ThirdParty = 2,
}

export interface EmployeeModel extends IdModel {
    firstname: string;
    lastname: string;
}

export interface FileUploadResponse {
    id?: string;
}

export interface FileModel extends IdModel {
    attributes: { [key: string]: any; };
    url: string;
    contentType: string;
    variants: { [key: string]: FileVariantModel; };
    uploadedBy?: string | undefined;
    uploadedByTypeId?: string | undefined;
    isVendor: boolean;
    isResource: boolean;
    isCustomer: boolean;
    created: string;
    size: number;
}

export interface FileVariantModel {
    url: string;
}

export interface FindAssetResponse {
    assets?: AssetModel[] | undefined;
}

export interface EntityWithTypeModel extends IdModel {
    typeId: string;
    typeName: string;
}

export interface EntityWithNameAndTypeModel extends EntityWithTypeModel {
    name: string;
}

export interface AssetModel extends EntityWithNameAndTypeModel {
    description?: string | undefined;
    productId?: string | undefined;
    isActive?: boolean;
    attributes: { [key: string]: any; };
    children: string[];
    conditionIssueInstances: string[];
    locationId?: string | undefined;
    parentId?: string | undefined;
    images: ImageModel[];
}

export interface ImageModel {
    url?: string | undefined;
    thumbnailUrl?: string | undefined;
}

export interface UpdateDeviceResourceRelationRequest {
    deviceResourceCollection?: DeviceResource[] | undefined;
}

export interface DeviceResource {
    resourceId?: string | undefined;
    assetId?: string;
}

export interface UserInventoryResponse {
    locations: InventoryLocationModel[];
    items: InventoryItemModel[];
}

export interface EnumModel extends IdModel {
    name: string;
}

export interface InventoryLocationModel extends EnumModel {
}

export interface InventoryItemModel {
    id: string;
    name: string;
    productId: string;
    productName?: string | undefined;
    locationId: string;
    quantity: number;
}

export interface IssueInventoryRequest {
    serviceTaskId: string;
    orderId: string;
    propertyId: string;
    items: TransactionInventoryModel[];
    locationId: string;
}

export interface TransactionInventoryModel {
    productId: string;
    quantity: number;
}

export interface ReceiveInventoryRequest {
    items: TransactionInventoryModel[];
    locationId: string;
    serviceTaskId: string;
    orderId: string;
    propertyId: string;
}

export interface BaseResponse3 {
    success?: boolean;
    errorMessage?: string | undefined;
    errorCode?: string | undefined;
}

export interface CreateLocationResponse extends BaseResponse3 {
    id?: string;
}

export interface CreateLocationRequest {
    id?: string | undefined;
    name: string;
    typeId: string;
    parentId?: string | undefined;
    propertyId?: string | undefined;
    order?: number | undefined;
    attributes?: AttributeModel[] | undefined;
}

export interface AttributeModel {
    key?: string | undefined;
    value?: string | undefined;
}

export interface UpdateLocationRequest {
    name?: string | undefined;
    parentId?: string | undefined;
    propertyId?: string | undefined;
    order?: number | undefined;
    attributes?: AttributeModel[] | undefined;
}

export interface SearchLocationResponse {
    locations?: LocationModel[] | undefined;
}

export interface EntityModel {
    id?: string;
}

export interface LocationModel extends EntityModel {
    name?: string | undefined;
    typeId?: string;
    typeName?: string | undefined;
    parentId?: string | undefined;
    propertyId?: string | undefined;
    order?: number | undefined;
    attributes?: AttributeModel[] | undefined;
}

export interface SearchLocationRequest {
    ids?: string[] | undefined;
    propertyId?: string | undefined;
    propertyIds?: string[] | undefined;
    parentId?: string | undefined;
    attributes?: { [key: string]: any; } | undefined;
}

export interface AccessCodeRequest {
    propertyId?: string;
    type?: AccessType;
}

export enum AccessType {
    Unknown = 0,
    Customer = 1,
    Vendor = 2,
    User = 3,
}

export interface SearchLockboxRequest {
    status?: string | undefined;
}

export interface InstallLockboxRequest {
    lockboxId: string;
    propertyId: string;
}

export interface UninstallLockboxRequest {
    lockboxId?: string;
}

export interface CreateLogRequest {
    name: string;
    timestamp: string;
    payload: { [key: string]: any; };
}

export interface NotificationModel {
    id: string;
    created: string;
    isPinned?: boolean;
    isPinnedByUser?: boolean;
    title?: string | undefined;
    body?: string | undefined;
    badgeText?: string | undefined;
    badgeColorClass?: string | undefined;
}

export interface OrderDetailsResponse {
    order: OrderModel;
    customers: OrderCustomerModel[];
    scoping: OrderScopingModel;
    properties: OrderPropertiesModel;
    files: { [key: string]: FileModel; };
    locations: { [key: string]: LocationModel2; };
    assets: { [key: string]: AssetModel; };
    condititionIssueInstances: { [key: string]: ConditionIssueInstanceModel; };
    inventory: { [key: string]: ServiceTaskInventoryModel; };
    remedyInstances: { [key: string]: RemedyInstanceModel; };
    isNoteReadStatusAvailable: boolean;
    isFilesAvailable: boolean;
    currentUserBidApprovalLimit?: number | undefined;
}

export interface OrderModel extends EntityWithNameAndTypeModel {
    property: PropertyModel;
    sourceSystem?: string | undefined;
    description?: string | undefined;
    statusId: string;
    statusName: string;
    subStatusId?: string | undefined;
    subStatusName?: string | undefined;
    priceListId: string;
    serviceTasks: OrderServiceTaskModel[];
    notes: OrderNoteModel[];
    bookings: OrderBookingModel[];
    tags: string[];
    preferredTimes: OrderPreferredTimeModel[];
    bids: BidModel[];
    vendor?: OrderVendorModel | undefined;
    isVendorInternal?: boolean | undefined;
    isExternalVendor4Services?: boolean | undefined;
    assignedVendorId?: string | undefined;
    hasChildren?: boolean | undefined;
    created: string;
    updated: string;
    priorityId?: string | undefined;
    priorityName?: string | undefined;
    serviceRequestId?: string | undefined;
    serviceRequestName?: string | undefined;
    serviceRequestNumber?: string | undefined;
    serviceRequestTeamName?: string | undefined;
    numberOfConditionIssues?: number;
    primoInspectionId?: string | undefined;
    lifecycleId?: string | undefined;
    lifecycleNumber?: string | undefined;
    estimatedDuration?: number;
    customerId?: string | undefined;
    estimatedCompletionDate?: string | undefined;
    invitationDate?: string | undefined;
}

export interface PropertyModel extends IdModel {
    address: AddressModel;
    geoCoordinates: GeoCoordinatesModel;
    propertyStatusId?: string;
    propertyNo?: string | undefined;
    market?: string | undefined;
    unitStatus?: string | undefined;
    region?: string | undefined;
    rent?: number | undefined;
    bedrooms?: number | undefined;
    bathrooms?: number | undefined;
    floorPlan?: string | undefined;
    yearBuilt?: string | undefined;
    unitSqFt?: number | undefined;
    gateCode?: string | undefined;
    moveOutDate?: string | undefined;
    moveInDate?: string | undefined;
    acquiredTypeId?: string;
    acquiredTypeName?: string | undefined;
    occupancyType?: string | undefined;
    certificationDate?: string | undefined;
    inServiceDate?: string | undefined;
    constructionStatusName?: string | undefined;
    doe?: boolean;
    subDivision?: string | undefined;
    signRestrictions?: SignRestrictionModel[] | undefined;
}

export interface AddressModel {
    street?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
    state?: string | undefined;
}

export interface GeoCoordinatesModel {
    latitude: number;
    longitude: number;
}

export interface SignRestrictionModel {
    id?: string;
    signRestrictionId?: string;
    value?: string | undefined;
}

export interface OrderServiceTaskModel extends EntityWithTypeModel {
    description?: string | undefined;
    statusId: string;
    statusName?: string | undefined;
    isPictureRequired: boolean;
    assetId?: string | undefined;
    locationId?: string | undefined;
    remedyInstanceId?: string | undefined;
    created?: string;
    updated?: string;
}

export interface OrderNoteModel extends IdModel {
    title: string;
    description: string;
    authorUserId?: string | undefined;
    authorUserName?: string | undefined;
    isRead?: boolean;
    created: string;
    isVisibleForExternalUsers?: boolean | undefined;
    bidId?: string | undefined;
}

export interface OrderBookingModel extends IdModel {
    resourceName: string;
    resourceId: string;
    resourceEmail?: string | undefined;
    resourcePhone?: string | undefined;
    userId?: string | undefined;
    startTime: string;
    endTime: string;
    actualStartTime?: string | undefined;
    actualEndTime?: string | undefined;
    statusId: string;
    statusName?: string | undefined;
    created?: string;
    isLocked?: boolean;
}

export interface OrderPreferredTimeModel {
    weekDay: DayOfWeek;
    weekDayName: string;
    dayTimeId: string;
    dayTimeName: string;
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export interface BaseBidModel extends EntityWithNameModel {
    created: string;
    updated: string;
    conditionIssueInstanceId: string;
    vendorId: string;
    statusId: string;
    statusName: string;
    notes?: string | undefined;
    options: BidOptionModel[];
    submittedOn?: string | undefined;
    submittedByUserId?: string | undefined;
    invoices?: InvoiceModel[] | undefined;
}

export interface BidModel extends BaseBidModel {
    relatedBids?: RelatedBidModel[] | undefined;
    serviceRequestTotalApprovedPrice?: number | undefined;
    approvalGroupName?: string | undefined;
    chargeback?: ChargebackModel | undefined;
}

export interface RelatedBidModel extends BaseBidModel {
}

export interface BidOptionModel extends EntityWithNameModel {
    isPreferred?: boolean;
    canPerformNow?: boolean;
    earliestWorkDate?: string | undefined;
    services: BidOptionServiceModel[];
    created: string;
    updated: string;
    price?: number;
    statusId?: string | undefined;
    statusName?: string | undefined;
    createdByUserId?: string | undefined;
}

export interface BidOptionServiceModel {
    remedyInstanceId: string;
    remedyInstance?: BidOptionServiceRemedyInstanceModel | undefined;
    id: string;
    serviceId: string;
    quantity: number;
    unitPrice: number;
    vendorTax: number;
    vendorChargeCode?: string | undefined;
    created: string;
    updated: string;
    accountingCodeId?: string;
}

export interface BidOptionServiceRemedyInstanceModel extends EntityWithNameModel {
    remedyId: string;
    description?: string | undefined;
}

export interface InvoiceModel extends IdModel {
    number: string;
    description?: string | undefined;
    dueDate: string;
    issueDate: string;
    created: string;
    statusId: string;
    statusName: string;
    relatedTargetId: string;
    relatedTargetType: string;
    lineItems: InvoiceLineItemModel[];
    amount: number;
    amountPaid?: number | undefined;
    typeId?: string | undefined;
    typeName?: string | undefined;
    checks: InvoiceCheckModel[];
}

export interface InvoiceLineItemModel extends IdModel {
    notes: string;
    amount: number;
}

export interface InvoiceCheckModel extends IdModel {
    checkNumber: string;
    amount: number;
    checkDate: string;
    clearDate?: string | undefined;
}

export interface ChargebackModel extends IdModel {
    bidId: string;
    statusId: string;
    statusName?: string | undefined;
    chargebackRemedies?: ChargebackRemedyModel[] | undefined;
}

export interface ChargebackRemedyModel extends IdModel {
    remedyInstanceId: string;
    amount: number;
    description?: string | undefined;
}

export interface OrderVendorModel extends EntityWithNameModel {
    email?: string | undefined;
    phone?: string | undefined;
    address?: AddressModel | undefined;
    isActive?: boolean;
    vendorNo?: string | undefined;
}

export interface OrderCustomerModel extends IdModel {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    homePhone?: string | undefined;
    otherPhone?: string | undefined;
    isPrimary?: boolean;
}

export interface OrderScopingModel {
    isVisible: boolean;
    isEditorVisible: boolean;
    isMaintenance: boolean;
    inspectedIds: string[];
}

export interface OrderPropertiesModel {
    isIncomplete: boolean;
    isAssignedForToday: boolean;
    isAssignedForTomorrow: boolean;
}

export interface LocationModel2 extends EntityWithNameAndTypeModel {
    parentId?: string | undefined;
    order?: number | undefined;
    children: string[];
    assets: string[];
    conditionIssueInstances: string[];
}

export interface ConditionIssueInstanceModel extends EntityWithNameAndTypeModel {
    notes?: string | undefined;
    locationId?: string | undefined;
    locationTypeId?: string | undefined;
    assetId?: string | undefined;
    assetTypeId?: string | undefined;
    assetTypeName?: string | undefined;
    statusId: string;
    statusName: string;
    priorityId?: string | undefined;
    priorityName?: string | undefined;
    conditionIssueId: string;
    conditionIssueName: string;
    conditionIssueCategoryId: string;
    conditionIssueCategoryName: string;
    remedyInstances: string[];
    created: string;
    updated: string;
    hasWarranty?: boolean | undefined;
    estimatedDuration: number;
    serviceRequestId?: string | undefined;
    isUnknownConditionIssue?: boolean;
}

export interface ServiceTaskInventoryModel {
    locationId: string;
    serviceTaskId: string;
    items: ServiceTaskInventoryItemModel[];
}

export interface ServiceTaskInventoryItemModel {
    productId: string;
    productName?: string | undefined;
    quantity: number;
}

export interface RemedyInstanceModel extends EntityWithNameAndTypeModel {
    conditionIssueInstanceId: string;
    description?: string | undefined;
    remedyId: string;
    assignment?: AssignmentModel | undefined;
    services: SelectedServiceModel[];
    products: SelectedProductModel[];
}

export interface AssignmentModel {
    typeId?: string;
    vendorId?: string | undefined;
}

export interface SelectedItemModel {
    id: string;
    quantity?: number;
    unitPrice?: number;
    unitPriceOnPriceList?: number;
    vendorTax?: number;
    vendorChargeCode?: string | undefined;
}

export interface SelectedServiceModel extends SelectedItemModel {
    serviceId: string;
}

export interface SelectedProductModel extends SelectedItemModel {
    productId: string;
}

export interface QueryOrderFilesResponse {
    urlsGeneratedSuccessfully: boolean;
    items: OrdersFilesResponse[];
}

export interface OrdersFilesResponse {
    orderId: string;
    files: { [key: string]: FileModel; };
}

export interface SearchWorkOrdersRequest {
    resourceIds?: string[] | undefined;
    statusIds?: string[] | undefined;
    subStatusIds?: string[] | undefined;
    paging?: PagingModel | undefined;
}

export interface PagingModel {
    pageIndex?: number;
    pageSize?: number;
    sortBy?: string | undefined;
    sortAscending?: boolean;
}

export interface VendorAdminOrdersResponse {
    orders: OrderDetailsResponse[];
    filterData: OrderFiltersData;
    hasNextPage: boolean;
}

export interface OrderFiltersData {
    propertyData: PropertyFilterData[];
    resourceData: ResourceData[];
    countByStatus: { [key: string]: number; };
    countBySubStatus: { [key: string]: { [key: string]: number; }; };
}

export interface PropertyFilterData extends IdModel {
    state?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
}

export interface ResourceData extends EntityWithNameModel {
}

export interface VendorAdminOrdersRequest {
    type: VendorOrderRequestType;
    query?: string | undefined;
    orderIds?: string[] | undefined;
    propertyIds?: string[] | undefined;
    resourceIds?: string[] | undefined;
    typeIds?: string[] | undefined;
    priorityIds?: (string | undefined)[] | undefined;
    categoryIds?: string[] | undefined;
    statuses?: { [key: string]: string[]; } | undefined;
    paging?: PagingModel | undefined;
}

export enum VendorOrderRequestType {
    AllOpen = "AllOpen",
    SchedulingRequired = "SchedulingRequired",
    Scheduled = "Scheduled",
    InProgress = "InProgress",
    ActionRequired = "ActionRequired",
    PendingAMHAction = "PendingAMHAction",
    Posted = "Posted",
}

export interface VendorAdminNotesOrderModel extends EntityWithNameModel {
    priorityId?: string | undefined;
    isNoteReadStatusAvailable: boolean;
    notes: OrderNoteModel[];
    statusId?: string;
    statusName?: string | undefined;
}

export interface VendorAdminOrderModel extends OrderModel {
    conditionIssueInstances: ConditionIssueInstanceAcceptanceModel[];
}

export interface ConditionIssueInstanceAcceptanceModel extends ConditionIssueInstanceModel {
    assetName?: string | undefined;
    locationName?: string | undefined;
}

export interface MutateOrderStateRequest {
    timestamp?: string;
    orderId?: string;
    orderStatusId?: string | undefined;
    orderSubStatusId?: string | undefined;
    orderBookingStatusId?: string | undefined;
    orderBookingId?: string | undefined;
    startTime?: string | undefined;
    endTime?: string | undefined;
    note?: OrderNote | undefined;
    isFrontendOnly?: boolean | undefined;
}

export interface OrderNote {
    id: string;
    title: string;
    description: string;
    isVisibleForExternalUsers?: boolean | undefined;
}

export interface NewServiceTaskModel {
    id: string;
    assetId?: string | undefined;
    locationId?: string | undefined;
    remedyInstanceId?: string | undefined;
    taskTypeId?: string;
    description: string;
}

export interface CreateServiceTaskRequest {
    id: string;
    assetId?: string | undefined;
    locationId?: string | undefined;
    remedyInstanceId?: string | undefined;
    taskTypeId: string;
    description: string;
}

export interface UpdateServiceTaskRequest {
    id: string;
    description?: string | undefined;
    orderId: string;
    remedyId: string;
}

export interface AddOrUpdateNoteRequest {
    id: string;
    orderId?: string;
    title: string;
    description: string;
    isVisibleForExternalUsers?: boolean | undefined;
}

export interface UpdatePreferredTimesRequest {
    serviceRequestId: string;
    preferredServiceTimes: PreferredServiceTime[];
}

export interface PreferredServiceTime {
    weekDay?: DayOfWeek;
    dayTimeId?: string;
}

export interface BatchUpdateNoteStatusRequest {
    ids: string[];
    isRead: boolean;
}

export interface BatchUpdateBookingLockRequest {
    operations: UpdateBookingLockOperation[];
}

export interface UpdateBookingLockOperation {
    orderId: string;
    bookingId: string;
    isLocked: boolean;
}

export interface SetCoordinatesRequest {
    propertyId: string;
    latitude: number;
    longitude: number;
}

export interface PropertyHistoryModel {
    propertyId?: string;
    isFilesAvailable?: boolean;
    serviceRequests?: ServiceRequestHistoryModel[] | undefined;
    orders?: OrderHistoryModel[] | undefined;
    serviceTasks?: ServiceTaskHistoryModel[] | undefined;
    conditionIssueInstances?: ConditionIssueInstanceHistoryModel[] | undefined;
}

export interface ServiceRequestHistoryModel extends EntityWithNameAndTypeModel {
    number: string;
    statusId: string;
    statusName: string;
    priorityId?: string | undefined;
    priorityName?: string | undefined;
    originId: string;
    originName: string;
    created: string;
    closed?: string | undefined;
    teamId?: string | undefined;
    teamName?: string | undefined;
    conditionIssueIds: string[];
}

export interface OrderHistoryModel extends EntityWithNameAndTypeModel {
    statusId: string;
    statusName: string;
    subStatusId?: string | undefined;
    subStatusName?: string | undefined;
    assignedVendorId?: string | undefined;
    assignedVendorName?: string | undefined;
    isAssignedVendorInternal?: boolean | undefined;
    created: string;
    closed?: string | undefined;
    priorityId?: string | undefined;
    priorityName?: string | undefined;
    serviceRequestId?: string | undefined;
    serviceRequestName?: string | undefined;
    serviceRequestNumber?: string | undefined;
    conditionIssueIds: string[];
}

export interface ServiceTaskHistoryModel extends EntityWithTypeModel {
    statusId: string;
    statusName?: string | undefined;
    description?: string | undefined;
    assetId?: string | undefined;
    assetName?: string | undefined;
    assetTypeId?: string | undefined;
    assetTypeName?: string | undefined;
    locationId?: string | undefined;
    locationName?: string | undefined;
    locationTypeId?: string | undefined;
    locationTypeName?: string | undefined;
    remedyInstanceId?: string | undefined;
    created: string;
    completed?: string | undefined;
    completedBy?: string | undefined;
    serviceRequestId?: string | undefined;
    serviceRequestName?: string | undefined;
    serviceRequestNumber?: string | undefined;
    orderId?: string | undefined;
    orderName?: string | undefined;
}

export interface ConditionIssueInstanceHistoryModel extends EntityWithNameAndTypeModel {
    locationId?: string | undefined;
    locationName?: string | undefined;
    locationTypeId?: string | undefined;
    locationTypeName?: string | undefined;
    assetId?: string | undefined;
    assetName?: string | undefined;
    assetTypeId?: string | undefined;
    assetTypeName?: string | undefined;
    statusId?: string;
    statusName?: string | undefined;
    priorityId?: string | undefined;
    priorityName?: string | undefined;
    conditionIssueId?: string;
    conditionIssueCategoryName?: string | undefined;
    remedyInstanceIds: string[];
    photoIds: string[];
    created: string;
    completed?: string | undefined;
    serviceRequestId?: string | undefined;
    serviceRequestName?: string | undefined;
    serviceRequestNumber?: string | undefined;
    orderId?: string | undefined;
    orderName?: string | undefined;
}

export interface GlobalReferenceDataModel {
    taxonomies?: { [key: string]: TaxonomyModel; } | undefined;
    stateMachines?: { [key: string]: any; } | undefined;
    scoping?: { [key: string]: ReferenceItemModel; } | undefined;
    assetTypeAttributes?: { [key: string]: AssetTypeAttributeModel[]; } | undefined;
}

export interface TaxonomyModel {
    name: string;
    items: TaxonomyItemModel[];
}

export interface TaxonomyItemModel extends EntityWithNameModel {
    attributes?: AttributeModel2[] | undefined;
    isHidden?: boolean | undefined;
    order?: number | undefined;
}

export interface AttributeModel2 {
    key: string;
    value?: string | undefined;
}

export interface ReferenceItemModel extends EnumModel {
    type?: ReferenceItemType;
    children?: string[] | undefined;
    childConditionIssues?: string[] | undefined;
    childLocations?: string[] | undefined;
    category?: EnumModel | undefined;
    isRoot?: boolean | undefined;
    service?: ServiceReferenceModel | undefined;
    isHidden?: boolean | undefined;
    description?: string | undefined;
    serviceTaskTypeId?: string | undefined;
    priorityId?: string | undefined;
    estimatedDuration?: number | undefined;
}

export enum ReferenceItemType {
    Location = "Location",
    Asset = "Asset",
    ConditionIssue = "ConditionIssue",
    Remedy = "Remedy",
    MeasureUnit = "MeasureUnit",
}

export interface ServiceReferenceModel extends IdModel {
    unit?: EnumModel | undefined;
    price?: { [key: string]: number; } | undefined;
}

export interface AssetTypeAttributeModel {
    key: string;
    name: string;
    isRequired?: boolean | undefined;
    type: AttributeValueType;
    isValueString?: boolean | undefined;
    isValueInt?: boolean | undefined;
    isValueDecimal?: boolean | undefined;
    isValueBool?: boolean | undefined;
    isValueDate?: boolean | undefined;
    isValueDateTime?: boolean | undefined;
    isValueTaxonomy?: boolean | undefined;
    items?: EnumModel[] | undefined;
}

export enum AttributeValueType {
    None = "None",
    String = "String",
    Int = "Int",
    Bool = "Bool",
    Decimal = "Decimal",
    Date = "Date",
    DateTime = "DateTime",
    Taxonomy = "Taxonomy",
}

export interface UserReferenceDataModel {
    userFullName?: string | undefined;
    vendors: VendorModel[];
}

export interface VendorModel extends EntityWithNameModel {
    characteristics?: CharacteristicModel[] | undefined;
}

export interface CharacteristicModel extends EntityWithNameModel {
}

export interface RemedyModel extends EntityWithNameModel {
    applicableTargets?: string[] | undefined;
    serviceTaskTypeId: string;
    serviceTaskTypeName: string;
    description?: string | undefined;
    estimatedDuration: number;
    statusId: string;
    statusName: string;
    service?: RemedyServiceModel | undefined;
}

export interface RemedyServiceModel {
    id: string;
    measureUnitId: string;
}

export interface CreateRemedyInstanceRequest {
    id: string;
    name: string;
    description?: string | undefined;
    conditionIssueInstanceId: string;
    remedyId: string;
    orderId: string;
    assignment?: AssignmentModel | undefined;
    services?: SelectedServiceModel[] | undefined;
    products?: SelectedProductModel[] | undefined;
    serviceTasks?: CreateServiceTaskRequest[] | undefined;
}

export interface UpdateRemedyInstanceRequest {
    id: string;
    name: string;
    description?: string | undefined;
    remedyId: string;
}

export interface UpdateRemedyInstanceAssignmentRequest {
    assignment?: AssignmentModel | undefined;
}

export interface BatchUpdateRemedyInstanceAssignmentRequest extends UpdateRemedyInstanceAssignmentRequest {
    ids: string[];
}

export interface UpdateRemedyInstanceServiceRequest {
    orderId: string;
    unitPrice?: number | undefined;
    quantity?: number | undefined;
    vendorTax?: number | undefined;
    vendorChargeCode?: string | undefined;
}

export interface ResourceModel extends EntityWithNameModel {
    email?: string | undefined;
    phone?: string | undefined;
    jobTitle?: string | undefined;
    userId?: string;
    territories: string[];
    categories: string[];
    hasStartingLocation?: boolean;
    timeZoneId?: string | undefined;
    timeZoneName?: string | undefined;
    isActive?: boolean;
    isAccountActive?: boolean;
}

export interface InspectionModel {
    reviewId: string;
    workOrderId: string;
    workOrderName?: string | undefined;
    statusId?: string;
    statusName?: string | undefined;
    address?: AddressModel | undefined;
}

export interface CreateReviewRequest {
    targetId?: string;
    targetType?: string | undefined;
    reviewTypeId?: string;
}

export interface SearchReviewsResponse {
    items: ReviewListItem[];
    hasNextPage: boolean;
}

export interface ReviewListItem {
    workOrderId: string;
    name: string;
    reviewId: string;
    address: string;
    technician: string;
    submitted: string;
    numberOfIssues: number;
    numberOfRemedies: number;
    status: string;
}

export interface SearchReviewsRequest {
    targetType?: string | undefined;
    query?: string | undefined;
    createdFrom?: string | undefined;
    createdTo?: string | undefined;
    paging?: PagingModel | undefined;
}

export interface VendorOfficeInfoModel {
    shortBusinessHours: string;
    timezone?: string | undefined;
    monday?: string | undefined;
    tuesday?: string | undefined;
    wednesday?: string | undefined;
    thursday?: string | undefined;
    friday?: string | undefined;
    saturday?: string | undefined;
    sunday?: string | undefined;
    phone: string;
    email: string;
}

export interface UserModel extends IdModel {
    resourceId: string;
    dripSchedulingEnabled?: boolean;
    permissions: string[];
    vendors: UserVendorModel[];
    vendor?: UserVendorModel | undefined;
}

export interface UserVendorModel extends EntityWithNameModel {
    vendorNo: string;
    isActiveUser?: boolean;
}

export interface UpdateCurrentGeoCoordinatesRequest {
    latitude: number;
    longitude: number;
    timestamp: string;
}

export interface CreateVoiceInspectionSessionResponse {
    sessionId: string;
    snapshot: VoiceInspectionSessionSnapshot;
}

export interface VoiceInspectionSessionSnapshot {
    sessionId: string;
    workOrderId: string;
    workOrderNumber: string;
    propertyId: string;
    status: VoiceInspectionSessionSnapshotStatus;
    revision: number;
    lastSequence: number;
    createdAt: string;
    updatedAt: string;
    expiresAt: string;
    findings: VoiceInspectionFinding[];
}

export interface VoiceInspectionFinding {
    enrichmentStatus?: string | undefined;
    id: string;
    rawText: string;
    targetType: string | undefined;
    targetId: string | undefined;
    targetName: string | undefined;
    locationTypeId: string | undefined;
    selectedAssetType?: EnumModel | undefined;
    category?: EnumModel | undefined;
    quantity: number | undefined;
    assignment: string | undefined;
    inferredConditionIssue: VoiceInspectionConditionIssue | undefined;
    inferredRemedyId: string | undefined;
    selectedConditionIssue: VoiceInspectionConditionIssue | undefined;
    selectedRemedyId: string | undefined;
    selfPerformCompleted: boolean;
    validationErrors: string[];
    unitPrice: number | undefined;
    catalogUnitPrice: number | undefined;
    serviceQuantity: number | undefined;
}

export interface VoiceInspectionConditionIssue {
    id: string;
    inferredRemedyId: string | undefined;
    name: string;
    description: string | undefined;
    confidence: number | undefined;
    explanation: string | undefined;
    assetTypeId: string | undefined;
    assetTypeName: string | undefined;
}

export interface CreateVoiceInspectionSessionRequest {
    workOrderId: string;
}

export interface VoiceInspectionRealtimeConnectionResponse {
    webSocketUrl: string;
    clientSecret: string;
    expiresAt: string;
}

export interface VoiceInspectionPricePreview {
    selectedRemedyId: string;
    catalogUnitPrice: number | undefined;
    validationError: string | undefined;
}

export interface VoiceInspectionFindingPatch {
    rawText?: string | undefined;
    targetId?: string | undefined;
    locationTypeId?: string | undefined;
    selectedAssetTypeId?: string | undefined;
    quantity?: number | undefined;
    assignment?: string | undefined;
    selectedConditionIssueId?: string | undefined;
    selectedRemedyId?: string | undefined;
    selfPerformCompleted?: boolean | undefined;
    unitPrice?: number | undefined;
    serviceQuantity?: number | undefined;
}

export interface SubmitVoiceInspectionSessionRequest {
    expectedRevision: number;
}

export interface EntityViewersModel {
    entityType?: string | undefined;
    entityId?: string;
    viewers?: EntityViewer[] | undefined;
}

export interface EntityViewer {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    timeStamp?: string;
    connectionId?: string | undefined;
    initials?: string | undefined;
}

export interface BatchUpdateConditionIssueInstanceEstimatedDurationCommand {
    operations: UpdateConditionIssueInstanceEstimatedDurationRequest[];
}

export interface CreateAssetCommand {
    id: string;
    name: string;
    assetTypeId: string;
    description?: string | undefined;
    parentId?: string | undefined;
    locationId?: string | undefined;
    propertyId: string;
    attributes?: { [key: string]: any; } | undefined;
}

export interface CreateBidChargebackCommand {
    id: string;
    bidId: string;
    chargebackRemedies: ChargebackRemedyRequest[];
    fileIds?: string[] | undefined;
}

export interface ChargebackRemedyRequest {
    id: string;
    remedyInstanceId: string;
    amount: number;
    description?: string | undefined;
}

export interface CreateBidCommand {
    id: string;
    notes?: string | undefined;
    options?: CreateOrUpdateFullBidOption[] | undefined;
    currentTenantId?: string | undefined;
    currentUserId?: string;
    orderId: string;
    conditionIssueInstanceId: string;
}

export interface CreateOrUpdateFullBidOption {
    id: string;
    earliestWorkDate?: string | undefined;
    canPerformNow?: boolean;
    isPreferred?: boolean;
    services: CreateOrUpdateFullBidService[];
}

export interface CreateOrUpdateFullBidService {
    id: string;
    serviceId: string;
    quantity: number;
    unitPrice: number;
    vendorTax: number;
    vendorChargeCode?: string | undefined;
    remedyInstance: CreateOrUpdateFullBidRemedyInstance;
}

export interface CreateOrUpdateFullBidRemedyInstance {
    id: string;
    remedyId: string;
    name: string;
    description?: string | undefined;
}

export interface CreateBidOrderNoteCommand {
    id: string;
    bidId: string;
    title: string;
    description: string;
    isVisibleForExternalUsers?: boolean;
    currentUserId?: string;
    currentTenantId?: string | undefined;
}

export interface CreateConditionIssueInstanceCommand extends CreateConditionIssueInstanceRequest {
}

export interface FileCreateRequest {
    fileId: string;
    attributes?: string | undefined;
}

export interface CreateFileCommand extends FileCreateRequest {
    currentUserId?: string;
    vendorId?: string | undefined;
    sourceName?: string | undefined;
}

export interface CreateLogCommand extends CreateLogRequest {
    currentUserId?: string;
}

export interface CreateOrderNoteCommand extends AddOrUpdateNoteRequest {
    currentUserId?: string;
    currentTenantId?: string | undefined;
}

export interface CreateRemedyInstanceCommand extends CreateRemedyInstanceRequest {
}

export interface CreateServiceTaskCommand extends CreateServiceTaskRequest {
    orderId?: string;
}

export interface DeleteConditionIssueInstanceCommand {
    id: string;
}

export interface DeleteFileCommand {
    id: string;
}

export interface DeleteRemedyInstanceCommand {
    id: string;
    orderId: string;
}

export interface EscalateConditionIssueInstanceCommand extends EscalateConditionIssueInstanceRequest {
    id?: string;
    currentUserId?: string;
}

export interface EvaluateBidStateMachineCommand {
    id?: string;
    actionName?: string | undefined;
    actionParameters?: { [key: string]: any; } | undefined;
}

export interface EvaluateConditionIssueInstanceStateMachineCommand {
    id?: string;
    actionName?: string | undefined;
    actionParameters?: { [key: string]: any; } | undefined;
}

export interface EvaluateOrderStateMachineCommand {
    id?: string;
    actionName?: string | undefined;
    actionParameters?: { [key: string]: any; } | undefined;
}

export interface EvaluateServiceTaskStatusCommand {
    orderId?: string;
    serviceTaskId?: string;
    actionName?: string | undefined;
    actionParameters?: { [key: string]: any; } | undefined;
}

export interface IssueInventoryCommand extends IssueInventoryRequest {
    currentUserId?: string;
}

export interface MutateOrderStateCommand extends MutateOrderStateRequest {
    currentUserId?: string;
}

export interface ReceiveInventoryCommand extends ReceiveInventoryRequest {
    currentUserId?: string;
}

export interface TestCommand {
    id?: string;
    name: string;
    name2: string;
    currentUserId?: string;
}

export interface UpdateAssetCommand {
    id: string;
    name: string;
    assetTypeId: string;
    description?: string | undefined;
    parentId?: string | undefined;
    locationId?: string | undefined;
    propertyId: string;
    isActive?: boolean | undefined;
    attributes?: { [key: string]: any; } | undefined;
}

export interface UpdateBidChargebackCommand {
    id: string;
    bidId: string;
    chargebackRemedies: ChargebackRemedyRequest[];
    fileIds?: string[] | undefined;
}

export interface UpdateBidChargebackStatusCommand {
    id: string;
    bidId: string;
    statusId: string;
}

export interface UpdateBidCommand {
    id: string;
    notes?: string | undefined;
    options?: CreateOrUpdateFullBidOption[] | undefined;
    currentTenantId?: string | undefined;
    currentUserId?: string;
}

export interface UpdateBidOrderNoteCommand {
    id: string;
    bidId: string;
    title: string;
    description: string;
    isVisibleForExternalUsers?: boolean;
    currentUserId?: string;
    currentTenantId?: string | undefined;
}

export interface UpdateBidServiceAccountingCodeCommand {
    id: string;
    bidId: string;
    optionId: string;
    overrideAccountingCodeId: string;
}

export interface UpdateConditionIssueInstanceCommand {
    id: string;
    description?: string | undefined;
    priorityId?: string | undefined;
    assetId?: string | undefined;
    conditionIssueId?: string | undefined;
}

export interface UpdateConditionIssueInstanceStatusCommand {
    id: string;
    statusId: string;
}

export interface UpdateOrderNoteCommand extends AddOrUpdateNoteRequest {
    currentUserId?: string;
    currentTenantId?: string | undefined;
}

export interface UpdateOrderNoteStatusCommand {
    id: string;
    currentUserId?: string;
    isRead?: boolean;
}

export interface UpdateRemedyInstanceCommand extends UpdateRemedyInstanceRequest {
}

export interface UpdateServiceTaskCommand {
    orderId?: string;
    serviceTaskId?: string;
    description?: string | undefined;
    remedyId?: string;
}

export interface UploadFileChunkCommand {
    fileId?: string;
    chunkIndex?: number;
    totalChunks?: number;
    fileName?: string | undefined;
    contentType?: string | undefined;
    currentUserId?: string;
}

export interface UploadFileContentCommand {
    file?: string | undefined;
    fileId: string;
    currentUserId?: string;
    fileName?: string | undefined;
    contentType?: string | undefined;
}

export enum VoiceInspectionSessionSnapshotStatus {
    Active = "active",
    Completed = "completed",
    Submitting = "submitting",
    Submitted = "submitted",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

/* tslint:disable */
/* eslint-disable */